module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_05_american-village-9f42606564ea9d0db9ad4f4f6daa77ee.jpg";